// AUTO-GENERATED FILE !! DO NOT EDIT !!

export const PERMISSIONS = {
  /**
   * Read provider data from feeds
   */
  READ_FEEDS: 'read:feeds',

  /**
   * Read logs and logging information
   */
  READ_LOGS: 'read:logs',

  /**
   * Run custom jobs
   */
  RUN_LOGS: 'run:logs',

  /**
   * Read end of day risk
   */
  READ_RISK_CALIBRATION: 'read:risk-calibration',

  /**
   * Read mappings
   */
  READ_MAPPINGS: 'read:mappings',

  /**
   * Add, update external mappings & swapagg mappings
   */
  WRITE_MAPPINGS: 'write:mappings',

  /**
   * Read monthly roll data
   */
  READ_MONTHLY_ROLL: 'read:monthly-roll',

  /**
   * Read trades
   */
  READ_TRADES: 'read:trades',

  /**
   * Book trades, update trades
   */
  WRITE_TRADES: 'write:trades',

  /**
   * Read IC Guidelines data
   */
  READ_IC_GUIDELINES: 'read:ic-guidelines',

  /**
   * Run IC Guidelines report for funds
   */
  RUN_IC_GUIDELINES: 'run:ic-guidelines',

  /**
   * Read IC Report
   */
  READ_IC_REPORT: 'read:ic-report',

  /**
   * Read RFQ data
   */
  READ_RFQ_DATA: 'read:rfq-data',

  /**
   * Read the status of IC Guidelines reports for each fund
   */
  READ_IC_GUIDELINES_STATUS: 'read:ic-guidelines-status',

  /**
   * Read transaction reporting
   */
  READ_TX_REPORTING: 'read:tx-reporting',

  /**
   * Update transaction reporting information
   */
  WRITE_TX_REPORTING: 'write:tx-reporting',

  /**
   * Whitelist your own IP to access on v1
   */
  ACCESS_V1: 'access:v1',

  /**
   * Read NAV Update
   */
  READ_NAV_UPDATE: 'read:nav-update',

  /**
   * Update information about fund NAVs
   */
  WRITE_NAV_UPDATE: 'write:nav-update',

  /**
   * Read EOD prices
   */
  READ_PRICE_VALIDATION: 'read:price-validation',

  /**
   * Update EOD prices
   */
  WRITE_PRICE_VALIDATION: 'write:price-validation',

  /**
   * Read Automated Nav
   */
  READ_AUTOMATED_NAV: 'read:automated-nav',

  /**
   * Read Positions & PnL
   */
  READ_POSITIONS_PNL: 'read:positions-pnl',

  /**
   * Read nt-hedging-fx-fwd page
   */
  READ_NT_HEDGING_FXFWD: 'read:nt-hedging-fxfwd',

  /**
   * Book, unwind, update and reset entries
   */
  WRITE_NT_HEDGING_FXFWD: 'write:nt-hedging-fxfwd',

  /**
   * Read Sales perf report
   */
  READ_PERF_REPORT: 'read:perf-report',

  /**
   * Upload trading data
   */
  WRITE_TRADING_DATA: 'write:trading-data',

  /**
   * Read smartrade trades
   */
  READ_SMARTRADE_TRADES: 'read:smartrade-trades',

  /**
   * Read Smartrade security entries
   */
  READ_SMARTRADE_DATA: 'read:smartrade-data',

  /**
   * Update, add Smartrade security entries
   */
  WRITE_SMARTRADE_DATA: 'write:smartrade-data',

  /**
   * Resend confirmations for Smartrade trades
   */
  WRITE_SMARTRADE_TRADES: 'write:smartrade-trades',

  /**
   * Read attributions - data presence
   */
  READ_DATA_PRESENCE: 'read:data-presence',

  /**
   * Write attributions - data presence
   */
  WRITE_DATA_PRESENCE: 'write:data-presence',

  /**
   * Read risk premia data
   */
  READ_RISK_PREMIA: 'read:risk-premia',

  /**
   * Run risk premia, validate final attribs, update risk premia
   */
  WRITE_RISK_PREMIA: 'write:risk-premia',

  /**
   * Read fixed income data
   */
  READ_FIXED_INCOME: 'read:fixed-income',

  /**
   * Send emails, run fixed income
   */
  WRITE_FIXED_INCOME: 'write:fixed-income',

  /**
   * Read daily composition
   */
  READ_DAILY_COMPOSITION: 'read:daily-composition',

  /**
   * Submit and upload to sftp
   */
  WRITE_DAILY_COMPOSITION: 'write:daily-composition',

  /**
   * Read upload track
   */
  READ_UPLOAD_TRACK: 'read:upload-track',

  /**
   * Update instruments data and upload files
   */
  WRITE_UPLOAD_TRACK: 'write:upload-track',

  /**
   * Read structured product information and details
   */
  READ_FLOW_POSMON: 'read:flow-posmon',

  /**
   * Update structured product information
   */
  WRITE_FLOW_POSMON: 'write:flow-posmon',

  /**
   * Read website data
   */
  READ_WEBSITE: 'read:website',

  /**
   * Write, update website information
   */
  WRITE_WEBSITE: 'write:website',

  /**
   * Create, submit and download factsheets
   */
  WRITE_FACTSHEETS: 'write:factsheets',

  /**
   * Run risk & scenario
   */
  WRITE_PRICING_INTERFACE: 'write:pricing-interface',

  /**
   * Read admin funds view
   */
  READ_ADMIN_FUNDS: 'read:admin-funds',

  /**
   * Update admin funds information
   */
  WRITE_ADMIN_FUNDS: 'write:admin-funds',

  /**
   * Read client pricing report
   */
  READ_CLIENT_PRICING: 'read:client-pricing',

  /**
   * Update, create, delete client pricing report
   */
  WRITE_CLIENT_PRICING: 'write:client-pricing',

  /**
   * Read fund attributions
   */
  READ_FUND_ATTRIBUTIONS: 'read:fund-attributions',

  /**
   * Read pricing interface
   */
  READ_PRICING_INTERFACE: 'read:pricing-interface',

  /**
   * Write cloud pricing, start, stop, reboot
   */
  WRITE_CLOUD_PRICING: 'write:cloud-pricing',

  /**
   * Create new instruments
   */
  CREATE_INSTRUMENTS: 'create:instruments',

  /**
   * Read and download time series data
   */
  READ_TIME_SERIES: 'read:time-series',

  /**
   * Read all instrument data
   */
  READ_INSTRUMENTS: 'read:instruments',

  /**
   * Send bespoke email invoice
   */
  SEND_BESPOKE_INVOICE: 'send:bespoke-invoice',

  /**
   * Read scheduled tasks
   */
  READ_SCHEDULED_TASKS: 'read:scheduled-tasks',

  /**
   * Run data presence, nt and banks
   */
  RUN_DATA_PRESENCE: 'run:data-presence',

  /**
   * Read PM Tracking Fund Flows
   */
  READ_FLOWS: 'read:flows',

  /**
   * Roll risk, update risk data
   */
  WRITE_RISK_CALIBRATION: 'write:risk-calibration',

  /**
   * CRUD for IC Guidelines
   */
  WRITE_IC_GUIDELINES: 'write:ic-guidelines',

  /**
   * Who can approve IC Guidelines after creating / modification
   */
  APPROVE_IC_GUIDELINES: 'approve:ic-guidelines',

  /**
   * Read markdata data, prices etc
   */
  READ_MARKETDATA: 'read:marketdata',

  /**
   * Run marketdata jobs
   */
  RUN_MARKETDATA_JOBS: 'run:marketdata-jobs',

  /**
   * Run EOD risk manually
   */
  RUN_RISK_CALIBRATION: 'run:risk-calibration',

  /**
   * Read P&L Validation page
   */
  READ_PNL_VALIDATION: 'read:pnl-validation',

  /**
   * Make changes on P&L Validation page
   */
  WRITE_PNL_VALIDATION: 'write:pnl-validation',

  /**
   * Approve / Reject changes for Ops P&L Validation
   */
  APPROVE_PNL_VALIDATION: 'approve:pnl-validation',

  /**
   * Amend market summary report
   */
  WRITE_MARKET_SUMMARY: 'write:market-summary',

  /**
   * Read the market summary report
   */
  READ_MARKET_SUMMARY: 'read:market-summary',
} as const

export type PERMISSION = (typeof PERMISSIONS)[keyof typeof PERMISSIONS]
